module.exports = __webpack_public_path__ + "static/media/kneehyperextension_mild_right.24373329.png";